// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.fix-rounded[data-v-4c0c0be2] {\n  border-radius: 4px !important;\n  border-top-left-radius: 4px !important;\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}", ""]);
// Exports
module.exports = exports;
